import { Cloud } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const PersistentServiceIcon = DeckardIconWrapper({ Icon: Cloud });
